export default theme => ({
  dateView: {
    overflow: 'hidden',
    textAlign: 'left',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center'
  },
  dateViewValue: {
    textOverflow: 'ellipsis',
    '&[data-warning=true]': {
      fontWeight: 'bold',
      color: theme.warningRed
    }
  },
  dateViewDeadlineIcon: {
    flexShrink: 1,
    width: 24,
    height: 24,
    marginLeft: 10,
    color: theme.warningRed
  }
});
